import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { bindActionCreators } from 'redux';
import * as actionCreators from '../actions/app';
import { connect } from 'react-redux';

import Loading from './loading.jsx'
import { ToastContainer, toast } from 'react-toastify'
import 'react-dates/initialize';
import {redirectToLogin} from '../api/redirect';

class home extends Component {
  handleToken = (nextLocation='') =>{
    const appData = JSON.parse(localStorage.getItem('appData')) || {};
    
    if(!appData.access_token){
      redirectToLogin();
    }else{

      this.props.changeLoginStatus(3)
      if(this.props.routing.locationBeforeTransitions.pathname === '/'){
        browserHistory.push('app');
      }
    }

  }

  componentWillMount = () => {
    this.handleToken();
  }

  render() {
    return (
      <div>
        <ToastContainer toastClassName="notif-main" position={toast.POSITION.BOTTOM_LEFT} autoClose={8000}/>
        <Loading />
        {this.props.children}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    app: state.app,
    routing : state.routing
  }
}

function mapDispachToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispachToProps)(home);